import {
  useInfiniteQuery,
  useQuery
} from '@tanstack/react-query'
import type {
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  GetOrderById200,
  GetOrderDetail200,
  GetOrders200,
  GetRecentOrders200,
  GetRecentOrdersParams
} from './types'
import { customInstance } from '../custom-axios';


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * @summary 주문 상세 조회 (v2)
 */
export const getOrderDetail = (
    orderId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetOrderDetail200>(
      {url: `/api/v1/orders/${orderId}/detail`, method: 'GET', signal
    },
      options);
    }
  

export const getGetOrderDetailQueryKey = (orderId: string,) => {
    return [`/api/v1/orders/${orderId}/detail`] as const;
    }

    
export const getGetOrderDetailInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getOrderDetail>>, TError = unknown>(orderId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOrderDetail>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrderDetailQueryKey(orderId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrderDetail>>> = ({ signal }) => getOrderDetail(orderId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(orderId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOrderDetail>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrderDetailInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getOrderDetail>>>
export type GetOrderDetailInfiniteQueryError = unknown

/**
 * @summary 주문 상세 조회 (v2)
 */
export const useGetOrderDetailInfinite = <TData = Awaited<ReturnType<typeof getOrderDetail>>, TError = unknown>(
 orderId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOrderDetail>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOrderDetailInfiniteQueryOptions(orderId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetOrderDetailQueryOptions = <TData = Awaited<ReturnType<typeof getOrderDetail>>, TError = unknown>(orderId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrderDetail>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrderDetailQueryKey(orderId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrderDetail>>> = ({ signal }) => getOrderDetail(orderId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(orderId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrderDetail>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrderDetailQueryResult = NonNullable<Awaited<ReturnType<typeof getOrderDetail>>>
export type GetOrderDetailQueryError = unknown

/**
 * @summary 주문 상세 조회 (v2)
 */
export const useGetOrderDetail = <TData = Awaited<ReturnType<typeof getOrderDetail>>, TError = unknown>(
 orderId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrderDetail>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOrderDetailQueryOptions(orderId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 최근 주문들을 조회합니다
 * @summary 최근 주문 조회
 */
export const getRecentOrders = (
    params?: GetRecentOrdersParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetRecentOrders200>(
      {url: `/api/v1/orders/recent`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetRecentOrdersQueryKey = (params?: GetRecentOrdersParams,) => {
    return [`/api/v1/orders/recent`, ...(params ? [params]: [])] as const;
    }

    
export const getGetRecentOrdersInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getRecentOrders>>, TError = unknown>(params?: GetRecentOrdersParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRecentOrders>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRecentOrdersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRecentOrders>>> = ({ signal }) => getRecentOrders(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRecentOrders>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRecentOrdersInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getRecentOrders>>>
export type GetRecentOrdersInfiniteQueryError = unknown

/**
 * @summary 최근 주문 조회
 */
export const useGetRecentOrdersInfinite = <TData = Awaited<ReturnType<typeof getRecentOrders>>, TError = unknown>(
 params?: GetRecentOrdersParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getRecentOrders>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRecentOrdersInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetRecentOrdersQueryOptions = <TData = Awaited<ReturnType<typeof getRecentOrders>>, TError = unknown>(params?: GetRecentOrdersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRecentOrders>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRecentOrdersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRecentOrders>>> = ({ signal }) => getRecentOrders(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRecentOrders>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRecentOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof getRecentOrders>>>
export type GetRecentOrdersQueryError = unknown

/**
 * @summary 최근 주문 조회
 */
export const useGetRecentOrders = <TData = Awaited<ReturnType<typeof getRecentOrders>>, TError = unknown>(
 params?: GetRecentOrdersParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRecentOrders>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetRecentOrdersQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 사용자의 주문 목록을 조회합니다
 * @summary 주문 목록 조회
 */
export const getOrders = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetOrders200>(
      {url: `/api/v1/orders`, method: 'GET', signal
    },
      options);
    }
  

export const getGetOrdersQueryKey = () => {
    return [`/api/v1/orders`] as const;
    }

    
export const getGetOrdersInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getOrders>>, TError = unknown>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOrders>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrdersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrders>>> = ({ signal }) => getOrders(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOrders>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrdersInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getOrders>>>
export type GetOrdersInfiniteQueryError = unknown

/**
 * @summary 주문 목록 조회
 */
export const useGetOrdersInfinite = <TData = Awaited<ReturnType<typeof getOrders>>, TError = unknown>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOrders>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOrdersInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetOrdersQueryOptions = <TData = Awaited<ReturnType<typeof getOrders>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrders>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrdersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrders>>> = ({ signal }) => getOrders(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrders>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof getOrders>>>
export type GetOrdersQueryError = unknown

/**
 * @summary 주문 목록 조회
 */
export const useGetOrders = <TData = Awaited<ReturnType<typeof getOrders>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrders>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOrdersQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 특정 주문의 상세 정보를 조회합니다
 * @summary 주문 상세 조회
 */
export const getOrderById = (
    orderId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetOrderById200>(
      {url: `/api/v1/orders/${orderId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetOrderByIdQueryKey = (orderId: string,) => {
    return [`/api/v1/orders/${orderId}`] as const;
    }

    
export const getGetOrderByIdInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getOrderById>>, TError = unknown>(orderId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOrderById>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrderByIdQueryKey(orderId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrderById>>> = ({ signal }) => getOrderById(orderId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(orderId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOrderById>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrderByIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getOrderById>>>
export type GetOrderByIdInfiniteQueryError = unknown

/**
 * @summary 주문 상세 조회
 */
export const useGetOrderByIdInfinite = <TData = Awaited<ReturnType<typeof getOrderById>>, TError = unknown>(
 orderId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getOrderById>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOrderByIdInfiniteQueryOptions(orderId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetOrderByIdQueryOptions = <TData = Awaited<ReturnType<typeof getOrderById>>, TError = unknown>(orderId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrderById>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrderByIdQueryKey(orderId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrderById>>> = ({ signal }) => getOrderById(orderId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(orderId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrderById>>, TError, TData> & { queryKey: QueryKey }
}

export type GetOrderByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getOrderById>>>
export type GetOrderByIdQueryError = unknown

/**
 * @summary 주문 상세 조회
 */
export const useGetOrderById = <TData = Awaited<ReturnType<typeof getOrderById>>, TError = unknown>(
 orderId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getOrderById>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetOrderByIdQueryOptions(orderId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



